import { regex } from "views/pages/manage/common/constant";
import moment from "moment";

export const getCashFilterFormFields = (dropdownData, reqForm) => {
  const { businessAreas = [], terms = [], userId = [] } = dropdownData || {};

  return [
    {
      label: 'Branch',
      type: 'select',
      items: businessAreas,
      formKey: 'businessArea',
      onChange: () => { },
      loading: false,
      isMulti: true,
      placeholder: "Select branch",
      disbabled: false,
      isShowCount: true
    },
    {
      label: 'User ID',
      type: 'text',
      items: userId,
      formKey: 'userId',
      onChange: () => { },
      loading: false,
      isMulti: false,
      placeholder: "Enter",
      disbabled: false,
      isShowCount: true
    },
    {
      label: 'Term',
      type: 'select',
      items: terms,
      formKey: 'term',
      onChange: () => { },
      loading: false,
      isMulti: true,
      placeholder: "Select",
      disbabled: false,
      isShowCount: true
    },
    {
      label: 'Payment management status',
      type: 'select',
      items: paymentStatus,
      formKey: 'status',
      onChange: () => { },
      loading: false,
      isMulti: true,
      placeholder: "Select",
      disbabled: false,
      isShowCount: true
    },
    {
      label: 'Payment management raised from',
      type: 'date',
      formKey: 'startDate',
      onChange: () => { },
      placeholder: "Select date",
      disabled: false,
      minDate: '',
      maxDate: moment(new Date()),
    },
    {
      label: 'Payment management raised to',
      type: 'date',
      formKey: 'endDate',
      onChange: () => { },
      placeholder: "Select date",
      disabled: false,
      minDate: reqForm?.startDate,
      maxDate: moment(new Date()),
    },
  ]
}
export const getChequeFilterFormFields = (dropdownData, reqForm) => {
  const { businessAreas = [], terms = [], cashierOffice, courseId } = dropdownData || {};

  return [
    {
      label: 'Branch',
      type: 'select',
      items: businessAreas,
      formKey: 'businessArea',
      onChange: () => { },
      loading: false,
      isMulti: true,
      placeholder: "Select branch",
      disbabled: false,
      isShowCount: true
    },
    {
      label: 'Cashier Office',
      type: 'select',
      items: cashierOffice,
      formKey: 'cashierOffice',
      onChange: () => { },
      loading: false,
      isMulti: true,
      placeholder: "Select",
      disbabled: false,
      isShowCount: true
    },
    {
      label: 'Course ID',
      type: 'select',
      items: courseId,
      formKey: 'courseId',
      onChange: () => { },
      loading: false,
      isMulti: true,
      placeholder: "Select",
      disbabled: false,
      isShowCount: true
    },
    {
      label: 'Term',
      type: 'select',
      items: terms,
      formKey: 'term',
      onChange: () => { },
      loading: false,
      isMulti: true,
      placeholder: "Select",
      disbabled: false,
      isShowCount: true
    },
    {
      label: 'Approval status',
      type: 'select',
      items: paymentStatus,
      formKey: 'status',
      onChange: () => { },
      loading: false,
      isMulti: true,
      placeholder: "Select",
      disbabled: false,
      isShowCount: true
    },
    {
      label: 'Cheque date from',
      type: 'date',
      formKey: 'startDate',
      onChange: () => { },
      placeholder: "Select date",
      disabled: false,
      minDate: '',
      maxDate: moment(new Date()),
    },
    {
      label: 'Cheque date to',
      type: 'date',
      formKey: 'endDate',
      onChange: () => { },
      placeholder: "Select date",
      disabled: false,
      minDate: reqForm?.startDate,
      maxDate: moment(new Date()),
    },
  ]
}

export const cashInitialFilterForm = {
  businessArea: [],
  userId: null,
  term: [],
  status: [],
  startDate: null,
  endDate: null
}
export const chequeInitialFilterForm = {
  businessArea: [],
  cashierOffice: [],
  courseId: [],
  term: [],
  status: [],
  startDate: null,
  endDate: null
}
export const paymentStatus = [
  { label: "Approved", value: "APPROVED" },
  { label: "Rejected", value: "REJECTED" },
  { label: "Pending", value: "PENDING" },
  { label: "Sent for correction", value: "SENT_FOR_CORRECTION" },
  // { label: "InProgress", value: "InProgress" }
];
export const cashSearchInputOptions = [
  {
    label: 'Deposit Slip No.',
    keyName: 'depositSlipNo',
    placeholder: 'Search by slip no.',
    // errorMsg: 'Please Enter 16 digit deposit slip no.',
    // regex: regex.cashDepositSlip,
    // isValidInput: val => val?.length === 16,
    // validLength: 16
  },
]
export const chequeSearchInputOptions = [
  {
    label: 'PSID',
    keyName: 'psid',
    placeholder: 'Search by psid',
    errorMsg: 'Please enter 11 digit psid.',
    regex: regex.numeric,
    isValidInput: val => val?.length === 11,
    validLength: 11
  },
]

export const APPROVAL_TYPE = {
  CASH: 'cash',
  CHEQUE: 'cheque'
};




export const dummyRow = [{
  businessAreaValue: "North Zone BU",
  cashierOffice: "Delhi Cashier Office",
  bank: "State Bank of India",
  depositSlipNo: "DSN-342342",
  depositSlipS3Key: "Slip-99345",
  cashierId: "CASH12345",
  receipts: "RCPT04523",
  ackId: "ACK-987654",
  ackDate: "2025-01-12T10:45:00",
  updatedOn: "2025-01-15T14:30:00",
  updatedBy: "John Doe",

  userActionDate: "2025-01-16T11:20:00",

  status: "APPROVED", // For CustomChip

  // Action-related keys
  psid: "PSID000123",
  applicationId: "APP987654",
  id: 123,

  isL1Approver: true,
  isL2Approver: false,
  isL3Approver: false,

  approvalStatus: "L1_PENDING", // Controls button enable
}];

export const CHEQUE_HEADER_CHIPS_CONFIG = [
  {
    key: "psid",
    label: "PSID",
    chipType: "TYPE"
  },
  {
    key: "referenceNumber",
    label: "Cheque no.",
    chipType: "TYPE"
  },
  {
    key: "oldChequeDate",
    label: "Old date",
    chipType: "TYPE",
    render: (value) => moment(value).format('DD/MM/YYYY')
  },
  {
    key: "newChequeDate",
    label: "New date",
    chipType: "TYPE",
    render: (value) => moment(value).format('DD/MM/YYYY')
  },
  {
    key: "bank",
    label: "Bank name",
    chipType: "BANK"
  },

];

export const getFilterDate=(date,filterType)=>{
  if(!date) return null;
  if(filterType== 'start')
   return  date ? moment(date).startOf('day'): '';
 else if(filterType== 'end')
    return  date ? moment(date).endOf('day'): '';
}
